import isArray from 'lodash/isArray';
import moment from 'moment';
import BaseApi from '@/api/controller/base';

const REPORT_API_URL = 'report/';
const DATE_RANGE_FORMAT = 'YYYY-MM-DD';
class ReportApi extends BaseApi {
  constructor() {
    super(REPORT_API_URL);
  }

  getDailyTrafficReport(dateRange, office, isPriorYear = false) {
    if (this._isValidDateRange(dateRange)) {
      return this.api.get('dailyTrafficReport', {
        params: this._getQueryProps(dateRange, office, isPriorYear),
      });
    }
    return Promise.reject(Error('Invalid date range.'));
  }

  getNewVsReturningReport(dateRange, office, isPriorYear = false) {
    if (this._isValidDateRange(dateRange)) {
      return this.api.get('newVsReturningReport', {
        params: this._getQueryProps(dateRange, office, isPriorYear),
      });
    }
    return Promise.reject(Error('Invalid date range.'));
  }

  getSchedulingReport(office, priorYearStartDate, currentYearStartDate) {
    return this.api.get('schedulingReport', {
      params: {
        office,
        priorYearStartDate,
        currentYearStartDate,
      },
    });
  }

  getOfficeSummaryReport(dateRange, office, isPriorYear = false) {
    if (this._isValidDateRange(dateRange)) {
      return this.api.get('officeSummaryReport', {
        params: this._getQueryProps(dateRange, office, isPriorYear),
      });
    }
    return Promise.reject(Error('Invalid date range.'));
  }

  getOfficeNvRReport(dateRange, office, isPriorYear = false) {
    if (this._isValidDateRange(dateRange)) {
      return this.api.get('officeNvRReport', {
        params: this._getQueryProps(dateRange, office, isPriorYear),
      });
    }
    return Promise.reject(Error('Invalid date range.'));
  }

  getEarlyBirdDistribution(dateRange, office, isPriorYear = false) {
    if (this._isValidDateRange(dateRange)) {
      return this.api.get('earlyBirdDistribution', {
        params: this._getQueryProps(dateRange, office, isPriorYear),
      });
    }
    return Promise.reject(Error('Invalid date range.'));
  }

  getEarlyBirdReasonsDNQ(dateRange, office, isPriorYear = false) {
    if (this._isValidDateRange(dateRange)) {
      return this.api.get('earlyBirdReasonsDNQ', {
        params: this._getQueryProps(dateRange, office, isPriorYear),
      });
    }
    return Promise.reject(Error('Invalid date range.'));
  }

  getEarlyBirdDNF(office) {
    return this.api.get('earlyBirdDNF', {
      params: {
        office,
      },
    });
  }

  getEarlyBirdNoAck(office) {
    return this.api.get('earlyBirdNoAck', {
      params: {
        office,
      },
    });
  }

  getHighReferralCount(office) {
    return this.api.get('highReferralCount', {
      params: {
        office,
      },
    });
  }

  _getQueryProps(dateRange, office, isPriorYear = false) {
    return {
      start: moment(dateRange[0]).format(DATE_RANGE_FORMAT),
      end: moment(dateRange[1]).format(DATE_RANGE_FORMAT),
      office,
      priorYear: isPriorYear,
    };
  }

  _isValidDateRange(dateRange) {
    return (isArray(dateRange) && dateRange.length === 2);
  }
}

const apiInstance = new ReportApi();
export { ReportApi, apiInstance };
export default apiInstance;
